import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generateCalendar from './generateCalendar';
const Calendar = generateCalendar(dayjsGenerateConfig);
export default Calendar;
